<input #stageImageSelect type="file" accept="image/*" multiple />
<div #svgContainer class='stage-svg-container'
></div>

<ng-content></ng-content>
@if (lowestImageQualityRating) {
  <div class="image-quality">
    @if (showQualityRatingCheckbox) {
      <span class="display-quality-indicators"
        [style.width.px]="qualityRatingWidth">
        <mat-checkbox [(ngModel)]="displayQualityIndicators"
          id="stage-check-image-quality"
                    (change)="updateQualityRating();
                              trackQualityRatingDisplay()">
          {{ 'i18n.control.imageQuality.checkImages' | translate }}
        </mat-checkbox>
      </span>
      <span class="spacer">|</span>
    }
    <image-quality-rating [calculationMode]="'static'"
      [staticQualityRatingValue]="lowestImageQualityRating"
    ></image-quality-rating>
  </div>
}
<div class="action-bars">
  <ng-template action-bars></ng-template>
</div>
